import { objectRemoveEmptyValues } from 'utils/common/object';

export const objectToQueryString = (params): string =>
  decodeURIComponent(new URLSearchParams(params).toString());

export const createGTMQueryString = (params) =>
  Object.entries(objectRemoveEmptyValues(params))
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
